module.exports = __webpack_public_path__ + "media/bootstrap-icons/layers-fill-78571717.svg";